import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ChangePremiumFee from "./ChangePremiumFee";
import ChangePassword from "./ChangePassword";
import LinkTelegramAccount from "./LinkTelegramAccount";
import { useSelector } from "react-redux";
import { selectAutomationAllowed } from "store/slices/main";
import { Alert, Divider } from "antd";
import { paths } from "utils/constants";

const UserSettings = () => {
  const automationAllowed = useSelector(selectAutomationAllowed);
  useEffect(() => {
    document.title = "Settings | Dindicator Dashboard";
  }, []);

  return (
    <>
      <Divider orientation="left">User Settings</Divider>
      {automationAllowed && (
        <Alert
          className="mb-4"
          type="info"
          showIcon
          message={
            <>
              AutoTrader's setup, IB Gateway and controls are on the{" "}
              <Link to={paths.automation}>Automation page</Link>.
            </>
          }
        />
      )}
      <div className="cards-wrapper">
        <ChangePassword />
        <ChangePremiumFee />
        <LinkTelegramAccount />
      </div>
    </>
  );
};

export default UserSettings;
